/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SklikIntegrationData
 */
export interface SklikIntegrationData {
    /**
     * 
     * @type {string}
     * @memberof SklikIntegrationData
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof SklikIntegrationData
     */
    created?: string;
    /**
     * 
     * @type {string}
     * @memberof SklikIntegrationData
     */
    updated?: string;
    /**
     * 
     * @type {string}
     * @memberof SklikIntegrationData
     */
    name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SklikIntegrationData
     */
    errors?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof SklikIntegrationData
     */
    authorizationSuccessful?: boolean;
    /**
     * 
     * @type {string}
     * @memberof SklikIntegrationData
     */
    lastRegularUpdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SklikIntegrationData
     */
    lastHistoricalUpdate?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SklikIntegrationData
     */
    project?: string;
    /**
     * 
     * @type {string}
     * @memberof SklikIntegrationData
     */
    apiKey?: string;
}

/**
 * Check if a given object implements the SklikIntegrationData interface.
 */
export function instanceOfSklikIntegrationData(value: object): value is SklikIntegrationData {
    return true;
}

export function SklikIntegrationDataFromJSON(json: any): SklikIntegrationData {
    return SklikIntegrationDataFromJSONTyped(json, false);
}

export function SklikIntegrationDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): SklikIntegrationData {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'created': json['created'] == null ? undefined : json['created'],
        'updated': json['updated'] == null ? undefined : json['updated'],
        'name': json['name'] == null ? undefined : json['name'],
        'errors': json['errors'] == null ? undefined : json['errors'],
        'authorizationSuccessful': json['authorizationSuccessful'] == null ? undefined : json['authorizationSuccessful'],
        'lastRegularUpdate': json['lastRegularUpdate'] == null ? undefined : json['lastRegularUpdate'],
        'lastHistoricalUpdate': json['lastHistoricalUpdate'] == null ? undefined : json['lastHistoricalUpdate'],
        'project': json['project'] == null ? undefined : json['project'],
        'apiKey': json['apiKey'] == null ? undefined : json['apiKey'],
    };
}

export function SklikIntegrationDataToJSON(json: any): SklikIntegrationData {
    return SklikIntegrationDataToJSONTyped(json, false);
}

export function SklikIntegrationDataToJSONTyped(value?: SklikIntegrationData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'created': value['created'],
        'updated': value['updated'],
        'name': value['name'],
        'errors': value['errors'],
        'authorizationSuccessful': value['authorizationSuccessful'],
        'lastRegularUpdate': value['lastRegularUpdate'],
        'lastHistoricalUpdate': value['lastHistoricalUpdate'],
        'project': value['project'],
        'apiKey': value['apiKey'],
    };
}

